export default "__VITE_ASSET__Cb66YFcn__"